"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObstaclesIcon = ObstaclesIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ObstaclesIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_13881)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#FFEBF5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.0477 10.8571C31.0477 10.6467 30.8771 10.4761 30.6667 10.4761H28.5626L25.8349 18.0952H31.0477V10.8571ZM19.6295 18.0952H23.4063L26.134 10.4761H22.3572L19.6295 18.0952ZM13.4227 18.0952H17.1995L19.9287 10.4761H16.1504L13.4227 18.0952ZM8.95246 18.0952H10.9941L13.7218 10.4761H9.33341C9.12302 10.4761 8.95246 10.6467 8.95246 10.8571V18.0952ZM33.3334 30.6666C33.3334 31.2978 32.8217 31.8095 32.1906 31.8095C31.5594 31.8095 31.0477 31.2978 31.0477 30.6666V20.3809H8.95246V30.6666C8.95246 31.2978 8.44079 31.8095 7.80961 31.8095C7.17842 31.8095 6.66675 31.2978 6.66675 30.6666V10.8571C6.66675 9.38434 7.86066 8.19043 9.33341 8.19043H30.6667C32.1395 8.19043 33.3334 9.38434 33.3334 10.8571V30.6666Z",
    fill: "#DA3A87"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_13881"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}